import { render, staticRenderFns } from "./PagePatientConsent.vue?vue&type=template&id=28d7c2b0&scoped=true"
import script from "./PagePatientConsent.vue?vue&type=script&lang=js"
export * from "./PagePatientConsent.vue?vue&type=script&lang=js"
import style0 from "./PagePatientConsent.vue?vue&type=style&index=0&id=28d7c2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d7c2b0",
  null
  
)

export default component.exports